jQuery( function( $ ) {

    /**
	 * Category gallery class.
	 */
	var CategoryGallery = function( $target, args ) {
		this.$target = $target;
		this.$images = $( '.woocommerce-category-gallery__image', $target );

		// No images? Abort.
		if ( 0 === this.$images.length ) {
			this.$target.css( 'opacity', 1 );
			return;
		}

		// Make this object available.
		$target.data( 'category_gallery', this );

        this.photoswipe_enabled = true;

		// Bind functions to this.
		this.initPhotoswipe       = this.initPhotoswipe.bind( this );
		this.getGalleryItems      = this.getGalleryItems.bind( this );
		this.openPhotoswipe       = this.openPhotoswipe.bind( this );

		if ( this.photoswipe_enabled ) {
			this.initPhotoswipe();
		}
	};

	/**
	 * Init PhotoSwipe.
	 */
	CategoryGallery.prototype.initPhotoswipe = function() {
		if ( this.$images.length > 0 ) {
			this.$target.on( 'click', '.woocommerce-category-gallery__image a', function( e ) {
				e.preventDefault();
			});
			// gallery images trigger photoswipe on click.
			this.$target.on( 'click', '.woocommerce-category-gallery__image a', this.openPhotoswipe );
		}
	};

	/**
	 * Get product gallery image items.
	 */
	CategoryGallery.prototype.getGalleryItems = function() {
		var $slides = this.$images,
			items   = [];

		if ( $slides.length > 0 ) {
			$slides.each( function( i, el ) {
				var img = $( el ).find( 'img' );

				if ( img.length ) {
					var large_image_src = img.attr( 'data-large_image' ),
						large_image_w   = img.attr( 'data-large_image_width' ),
						large_image_h   = img.attr( 'data-large_image_height' ),
						alt             = img.attr( 'alt' ),
                        link            = img.attr( 'data-link' ),
                        title           = img.attr( 'data-caption' ) ? img.attr( 'data-caption' ) : img.attr( 'title' ),
						item            = {
							alt     : alt,
							// src     : large_image_src,
							w       : large_image_w,
							h       : large_image_h,
							title   : title,
                            html    : '<div class="pswp-html"><a href="'+ link +'"><img src="'+ large_image_src +'" class="woocommerce-category-gallery__image_lg"></a></div>'
						};
					items.push( item );
				}
			} );
		}

		return items;
	};

	/**
	 * Open photoswipe modal.
	 */
	CategoryGallery.prototype.openPhotoswipe = function( e ) {
		e.preventDefault();

		var pswpElement = $( '.pswp' )[0],
			items       = this.getGalleryItems(),
			eventTarget = $( e.target ),
			clicked;
		
		clicked = eventTarget.closest( '.product' );

		var options = $.extend( {
			index: $( clicked ).index(),
			addCaptionHTMLFn: function( item, captionEl ) {
				if ( ! item.title ) {
					captionEl.children[0].textContent = '';
					return false;
				}
				captionEl.children[0].textContent = item.title;
				return true;
			}
		}, wc_single_product_params.photoswipe_options );

		// Initializes and opens PhotoSwipe.
		var photoswipe = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options );
		photoswipe.init();
	};

    /**
	 * Function to call wc_category_gallery on jquery selector.
	 */
	$.fn.wc_category_gallery = function() {
		new CategoryGallery( this );
		return this;
	};

	/*
	 * Initialize all galleries on page.
	 */
	$( '.woocommerce-category-gallery' ).each( function() {

		$( this ).wc_category_gallery();

	} );

} );